import React from "react";
import { Clock3 } from "lucide-react";

export default function TimeoutPopup({
  title = "Time is up",
  message = "Your mock test time has ended. We are submitting your answers now.",
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/55 px-4 backdrop-blur-sm">
      <div className="w-full max-w-md overflow-hidden rounded-md border border-slate-200 bg-white text-center shadow-2xl">
        <div className="h-1.5 bg-violet-600" />
        <div className="p-6">
          <span className="mx-auto grid h-14 w-14 place-items-center rounded-md bg-violet-50 text-violet-700 ring-1 ring-violet-100">
            <Clock3 className="h-7 w-7" aria-hidden="true" />
          </span>
          <h2 className="mt-4 text-2xl font-extrabold text-gray-900">
            {title}
          </h2>
          <p className="mt-3 text-sm leading-6 text-gray-600">{message}</p>
          <div className="mt-5 rounded-md bg-slate-50 px-4 py-3 text-sm font-bold text-violet-800 ring-1 ring-slate-100">
            Auto-submitting your mock test...
          </div>
        </div>
      </div>
    </div>
  );
}
